import { render } from "./slider.vue?vue&type=template&id=d971745c&scoped=true&ts=true"
import script from "./slider.vue?vue&type=script&lang=ts"
export * from "./slider.vue?vue&type=script&lang=ts"

import "./slider.vue?vue&type=style&index=0&id=d971745c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d971745c"]])

export default __exports__